import { useContext, useEffect } from 'react'
import { GlobalContext } from '../context/GlobalContext';

import './Pages.scss';
import TrackRequestLogin from '../components/TrackRequestLogin/TrackRequestLogin';
import TRFTTHOTP from './TRFTTHOTP/TRFTTHOTP';
import RequestLists from './RequestLists/RequestLists';
import RequestDetails from './RequestDetails/RequestDetails';
import Loading from '../components/Loading/Loading';
import AlertModal from '../components/AlertModal/AlertModal';
import { useTranslation } from 'react-i18next';
import ContactUsModal from '../components/ContactUsModal/ContactUsModal';
import FTTHSuccess from './FTTHSuccess/FTTHSuccess';
import CancelReasonModal from '../components/CancelReasonModal/CancelReasonModal';
import CancellationOTP from './CancellationOTP/CancellationOTP';

const win: any = window;

function TrackLogin() {
    const { state, dispatch }: any = useContext(GlobalContext);
    const { t } = useTranslation();
    const { page, loading, popup, rtl } = state;
    const urlParams = new URLSearchParams(window.location.search);

    useEffect(() => {
        const status = urlParams.get('status');
        const edata = urlParams.get('edata');

        if (status === 'failure') {
            window.location.href = win['base_portal_url'] + win['errorPageURL'];
        } else {
            if (edata) {
                const decode = window.decodeURIComponent(atob(edata ? edata : ""));
                const params = JSON.parse(decode);

                const requestDetails = {
                    MobilyOrderNumber: params.mo,
                    FirstName: params.fn,
                    FamilyName: params.ln,
                    BirthDate: params.dob,
                    NationalId: params.id,
                    MobileNumber: params.ph,
                    EmailAddress: params.em,
                    ShortNationalAddress: params.sna,
                    Region: params.re,
                    City: params.cy,
                    District: params.dt,
                    Street: params.st,
                    BuildingNumber: params.bg,
                    ZIPcode: params.zc,
                    PayType: params.pT
                }

                dispatch({ type: 'UPDATE_REQUEST_DETAILS', payload: requestDetails })
                dispatch({ type: 'UPDATE_PAGE', payload: 'successPage' })
            }
        }
    }, []);

    return (
        <main className='FTTH__TrackContainer'>
            {page === 'TR_Login' && <TrackRequestLogin />}
            {page === 'TR_OTP' && <TRFTTHOTP />}
            {page === 'requestList' && <RequestLists />}
            {page === 'requestDetails' && <RequestDetails />}
            {page === 'CANCELLATION_OTP' && <CancellationOTP />}
            {loading && (
                <Loading loading={loading} />
            )}
            {popup === 'noReqFound' && (
                <AlertModal
                    id={''}
                    title={t('No_request_found')}
                    description={t('Dont_found_order')}
                    sub_desc={t('if_it_mistake')}
                    rtl={rtl}
                    modalFirstButtonClick={() => { }}
                    firstButtonText={t('Got_it')}
                />
            )}
            {popup === 'somethingWrong' && (
                <ContactUsModal
                    id={'somethingWrong'}
                    rtl={rtl}
                    title={t('Something_went_wrong')}
                    description={t('Something_went_wrong_description')}
                    firstButtonText={t('TRY_AGAIN')}
                    secondButtonText={t('CONTACT_US')}
                />
            )}
            {page === 'successPage' && <FTTHSuccess />}
            {popup === 'cancelReason' && <CancelReasonModal />}
        </main>
    )
}

export default TrackLogin